import styled, { css } from 'styled-components';
import { BUTTON_SELECTOR } from '@ardoq/button';
import { colors, spacing } from '@ardoq/design-tokens';

const LEVEL_INDENT_PX = 24;
const NESTING_LINE_OFFSET_PX = 16;

export const Container = styled.div`
  position: relative;
  display: flex;
  align-self: stretch;
`;

export const NestingLine = styled.div<{ $depth: number }>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: ${({ $depth }) => NESTING_LINE_OFFSET_PX + $depth * LEVEL_INDENT_PX}px;
  width: 2px;
  background-color: ${colors.borderSubtle};
`;

export const Row = styled.div<{
  $level: number;
  $isDisabled: boolean;
}>`
  display: flex;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  align-items: center;
  gap: ${spacing.s8};
  margin-left: ${({ $level }) => ($level - 1) * LEVEL_INDENT_PX}px;
  padding: ${spacing.s8} ${spacing.s16};
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'default' : 'pointer')};
  ${({ $isDisabled }) =>
    !$isDisabled &&
    css`
      &:hover {
        background-color: ${colors.surfaceHover};
      }
    `}
`;

export const Controls = styled.div`
  display: flex;
  flex: 1 1 content;
  justify-content: flex-end;
  align-items: center;
  gap: ${spacing.s4};
  min-width: 0;
`;

export const InfoSlot = styled.div`
  display: flex;
`;

export const ControlSlot = styled.div`
  display: flex;
  ${BUTTON_SELECTOR} {
    min-height: 24px;
  }
`;
